export const EXPLORER_EXPLORATION_LOCAL_STORAGE_KEY = 'explorer-exploration';
